import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { BaivietAction } from 'src/actions/baiviet.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  DEFAULT_HOMEPAGE_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getBaivietStatus } from 'src/utils/utils';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';

import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";

import numeral from 'numeral';

import { Helmet } from "react-helmet";

import iconMobifone from "../../assets/images/icon_mobifone.png";
import iconVinaphone from "../../assets/images/icon_vinaphone.png";
import iconViettel from "../../assets/images/icon_viettel.png";

const TheHomepageBaivietDetail = ({ ...rest }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPage = queryParams.get("page");
  const [selectedBaivietIds, setSelectedBaivietIds] = useState([]);
  const [homepageBaivietLimit, setLimit] = useState(DEFAULT_HOMEPAGE_ROW_PER_PAGE);
  const [homepageBaivietPage, setPage] = useState(currentPage ? parseInt(currentPage) - 1 : 0);
  const { homepageBaivietItems, homepageBaivietTotal, homepageBaivietFilter } = useSelector(state => state.baiviet);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)
  const { isLoading } = useSelector(state => state.app);
  
  useEffect(() => {
    setPage(currentPage ? parseInt(currentPage - 1): 0);
  }, [currentPage])
  
  useEffect(() => {
    const payload = {
      ...homepageBaivietFilter,
      homepageBaivietLimit: homepageBaivietLimit,
      homepageBaivietPage: homepageBaivietPage,
    };
    dispatch(BaivietAction.updateHomepageFilter(payload));
    dispatch(BaivietAction.homepageList())
  }, [homepageBaivietPage, homepageBaivietLimit])

  const handleSelectAll = (event) => {
    let newSelectedBaivietIds;

    if (event.target.checked) {
      newSelectedBaivietIds = homepageBaivietItems.map((baiviet) => baiviet.id);
    } else {
      newSelectedBaivietIds = [];
    }

    setSelectedBaivietIds(newSelectedBaivietIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedBaivietIds.indexOf(id);
    let newSelectedBaivietIds = [];

    if (selectedIndex === -1) {
      newSelectedBaivietIds = newSelectedBaivietIds.concat(selectedBaivietIds, id);
    } else if (selectedIndex === 0) {
      newSelectedBaivietIds = newSelectedBaivietIds.concat(selectedBaivietIds.slice(1));
    } else if (selectedIndex === selectedBaivietIds.length - 1) {
      newSelectedBaivietIds = newSelectedBaivietIds.concat(selectedBaivietIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedBaivietIds = newSelectedBaivietIds.concat(
        selectedBaivietIds.slice(0, selectedIndex),
        selectedBaivietIds.slice(selectedIndex + 1)
      );
    }

    setSelectedBaivietIds(newSelectedBaivietIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);

    // Gán giá trị mặc định
    queryParams.set("page", newPage + 1);

    // Cập nhật URL mà không reload trang
    navigate({
      pathname: location.pathname,
      search: `?${queryParams.toString()}`
    }, { replace: true }); // replace để không thêm vào lịch sử trình duyệt
  };

  const handleConfirmOpen = (type, baiviet) => {
    setSelected(baiviet);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(BaivietAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(BaivietAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const totalPages = Math.ceil(homepageBaivietTotal / homepageBaivietLimit);
  
  const renderPagination = () => {
      const pages = [];
      const maxPagesToShow = 5;
      
      if (totalPages <= maxPagesToShow) {
          for (let i = 0; i < totalPages; i++) {
              pages.push(i);
          }
      } else {
          if (homepageBaivietPage > 2) pages.push(0, "...");
          for (let i = Math.max(0, homepageBaivietPage - 2); i <= Math.min(totalPages - 1, homepageBaivietPage + 2); i++) {
              pages.push(i);
          }
          if (homepageBaivietPage < totalPages - 3) pages.push("...", totalPages - 1);
      }
      
      return pages.map((page, index) => (
          <button className={`page-btn ${typeof page === "number" ? (currentPage && parseInt(currentPage) == page + 1 || !currentPage && page == 0 ? "current-selected" : "") : "not-number"}`} key={index} onClick={(e) => typeof page === "number" && handlePageChange(e, page)}
              disabled={page === homepageBaivietPage || page === "..."} style={{
                  padding: "8px 12px", background: page === homepageBaivietPage ? "var(--main-color)" : "var(--main-color)", color: "#fff",
                  border: "none", borderRadius: "5px", cursor: page === homepageBaivietPage || page === "..." ? "default" : "pointer",
                  margin: "0", transition: "0.3s"
              }}>
              {page === "..." ? "..." : page + 1}
          </button>
      ));
  };

  const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // hoặc 'auto'
    });
  };

  return (
    <>
        <Helmet>
          <title>Bài viết | Xe điện SH - Xe điện Song Đan</title>
        </Helmet>

        {isLoading && <div className='loading'></div>}

        {!isLoading && <div className='baiviet-list-show' style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px" }}>
            {homepageBaivietItems && homepageBaivietItems.slice(homepageBaivietPage * homepageBaivietLimit, homepageBaivietPage * homepageBaivietLimit + homepageBaivietLimit).map((baiviet, index) => (
                baiviet ? <Link to={`/trang-chu/bai-viet/${baiviet.slug}`} className="baiviet-item simvip" onClick={scrollToTop} onMouseEnter={e => e.currentTarget.style.border = "1px solid var(--main-color)"} onMouseLeave={e => e.currentTarget.style.border = "1px solid #ddd"} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", background: "#fff", textDecoration: "none", color: "inherit" }}>
                    {baiviet.image?.match(/\.(mp4|webm|ogg)$/i) ? (
                        <video src={baiviet.image} controls style={{ width: "40%", height: "200px" }} />
                    ) : (
                        <img src={baiviet.image ? baiviet.image : ''} alt={baiviet.title ? baiviet.title : ''} style={{ width: "40%", height: "200px", objectFit: "cover" }} />
                    )}
                    <div style={{width: "60%"}}>
                        <div className="title">{baiviet.title}</div>
                        <div className="date d-none">{moment(baiviet.createdAt).format('DD-MM-YYYY')}</div>
                        <div className="short-description">{baiviet.short_description}</div>
                    </div>
                </Link> : null
            ))}
        </div>}

        {!isLoading && <div className='list-pagination' style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px", gap: "5px" }}>
            <button onClick={(e) => handlePageChange(e, homepageBaivietPage - 1)} disabled={homepageBaivietPage === 0} style={{ padding: "10px 15px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", transition: "0.3s" }}
            onMouseEnter={e => e.target.style.background = "var(--main-color)"}
            onMouseLeave={e => e.target.style.background = "var(--main-color)"}>
                {"<"}
            </button>
            {renderPagination()}
            <button onClick={(e) => handlePageChange(e, homepageBaivietPage + 1)} disabled={homepageBaivietPage + 1 >= homepageBaivietTotal / homepageBaivietLimit} style={{ padding: "10px 15px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", transition: "0.3s" }}
            onMouseEnter={e => e.target.style.background = "var(--main-color)"}
            onMouseLeave={e => e.target.style.background = "var(--main-color)"}>
                {">"}
            </button>
        </div>}
    </>
  );
};

export default TheHomepageBaivietDetail;
